import { startCase, upperCase } from 'lodash'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import { fetchRegionMetatags, Metatags } from 'main/framework/metatag-manifest'
import { SearchPage } from '../Search/Content'

interface IProps extends RouteComponentProps<{ city?: string; state: string }> {}

export default function Region(props: IProps) {
  const {
    match: {
      params: { city, state },
    },
  } = props

  const region = { city: startCase(city), state: upperCase(state) }
  const location = region.city ? `${region.city}, ${region.state}` : region.state

  const { description, title, urlPath } = fetchRegionMetatags(location)

  const metatags: Metatags = [
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    {
      content: 'https://ucarecdn.com/2ebf7e06-dd17-444b-bb18-09adf1ed3870/schoolprofiletop.png',
      property: 'og:image',
    },
  ]

  return (
    <SearchPage
      query={location}
      metatags={{ description, metatags, title, urlPath }}
      region={region}
      ipLocation={null}
    />
  )
}
